/* eslint-disable @typescript-eslint/no-misused-promises */
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spacer,
  VStack,
} from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const schema = z.object({
  username: z.string().regex(/^[a-zA-Z0-9._%+-]+$/, 'Invalid characters in username'),
});

type FormData = z.infer<typeof schema>;

type Props = {
  isOpen: boolean;
  onSubmit: (values: FormData) => void;
};

export default function GuestSignInForm({ isOpen, onSubmit }: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Box p="20px" gap="10px">
            <Heading size="sm" pb="5">
              {t('meeting.signin.form.title')}
            </Heading>
            <form onSubmit={handleSubmit(onSubmit)}>
              <VStack gap="10px" pb="10px">
                <FormControl isRequired isInvalid={Boolean(errors.username)}>
                  <FormLabel fontSize="sm" fontWeight="normal" mb="1">
                    {t('meeting.signin.form.username.label')}
                  </FormLabel>
                  <Input
                    type="text"
                    {...register('username', { required: true })}
                    placeholder="ex: Bob Poulie"
                  />
                  {errors.username && (
                    <FormHelperText color="red">
                      {t('meeting.signin.form.username.error')}
                    </FormHelperText>
                  )}
                </FormControl>

                <Spacer h="5px" />

                <Button
                  onClick={handleSubmit(onSubmit)}
                  p="2"
                  width="full"
                  background="blue.400"
                  color="white"
                  variant="solid"
                >
                  {t('meeting.signin.form.submit.label')}
                </Button>
              </VStack>
            </form>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
